var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_13812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 0H0V100H100V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.051 0H0.0507812V100H100.051V0Z",
    fill: "url(#paint0_linear_113_13812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.051 0H0.0507812V100H100.051V0Z",
    fill: "url(#paint1_linear_113_13812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.051 0H0.0507812V100H100.051V0Z",
    fill: "url(#paint2_linear_113_13812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.051 0H0.0507812V100H100.051V0Z",
    fill: "url(#paint3_linear_113_13812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.051 0H0.0507812V100H100.051V0Z",
    fill: "url(#paint4_linear_113_13812)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_113_13812",
    x1: 82.4508,
    y1: 6.95,
    x2: 26.1508,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F2F8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4FDF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_113_13812",
    x1: 10.3508,
    y1: 89.9,
    x2: 44.7008,
    y2: 57.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#8DF9F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_113_13812",
    x1: 103.951,
    y1: 71.5,
    x2: 77.2008,
    y2: 36.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCECDE",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCECDE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_113_13812",
    x1: 87.1008,
    y1: 12,
    x2: 57.5508,
    y2: 41.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7774",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_113_13812",
    x1: 12.9008,
    y1: 4.25,
    x2: 50.1008,
    y2: 34.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB8F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_13812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarBg);
export default __webpack_public_path__ + "static/media/AvatarBg.9cea59a221918e19b78e7bbd060ab65f.svg";
export { ForwardRef as ReactComponent };